import { z } from 'zod';

export const AutomationSchema = z.object({
  automationName: z
    .string()
    .min(1, { message: 'error_field_required' })
    .max(255, {
      message: `error.field_max_lengh_255`,
    }),
  automationCode: z
    .string()
    .max(255, {
      message: `error.field_max_lengh_255`,
    })
    .optional(),
  businessAreaId: z.coerce
    .number({ message: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  processId: z.coerce
    .number({ message: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  tasks: z.any().optional(),
  description: z
    .string()
    .max(255, {
      message: `error.field_max_lengh_255`,
    })
    .optional(),
  stageId: z.coerce
    .number({ message: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  priority: z
    .string({ message: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  orchestratorProcessId: z.string({
    required_error: 'error_field_required',
  }),
  epicId: z.string({
    required_error: 'error_field_required',
  }),
  automationPdd: z.any().optional(),
  automationSdd: z.any().optional(),
  automationManualFile: z.any().optional(),
  automationsupportDocuments: z.any().optional(),
});

export const AutomationRequestSchema = z.object({
  name: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
  owner: z.coerce
    .number({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  description: z
    .string({
      required_error: 'error_field_required',
    })
    .max(255, {
      message: `error.field_max_lengh_255`,
    }),
  users: z.array(z.number()).optional(),
  tools: z.array(z.number()).optional(),
  duration: z.string({
    required_error: 'error_field_required',
  }),
  frequency: z.string({
    required_error: 'error_field_required',
  }),
  priority: z.string({
    required_error: 'error_field_required',
  }),
  additionalInformation: z.string().optional(),
  organizationId: z.coerce
    .number({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  companyId: z.coerce
    .number({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  businessAreaId: z.coerce
    .number({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  additionalFiles: z.array(z.instanceof(File)).optional(),
});

export const RequestStageSchema = z.object({
  additionalInfo: z
    .string()
    .max(255, {
      message: `error.field_max_lengh_255`,
    })
    .optional(),
  estimatedEffortTime: z.coerce.number().optional(),
  hourlyRate: z.coerce.number().optional(),
  stage: z.coerce.number().optional(),
});

export type FormAutomationSchemaType = z.infer<typeof AutomationSchema>;

export type FormAutomationRequestSchemaType = z.infer<
  typeof AutomationRequestSchema
>;

export type FormRequestStageSchemaType = z.infer<typeof RequestStageSchema>;

export interface AutomationSchemaType extends FormAutomationSchemaType {
  id?: number;
}

export interface AutomationRequestSchemaType
  extends FormAutomationRequestSchemaType {
  id?: number;
}

export interface RequestStageSchemaType extends FormRequestStageSchemaType {
  id?: number;
}
